import React, { useEffect, useMemo, useState } from 'react';
import {EuiButton, EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiProgress, EuiSpacer, EuiListGroup,EuiListGroupItem,EuiBadge} from '@elastic/eui';
import { AdjuntarComponent } from './component';
import { toDecimalString } from '../../../../../shared/utils/numbers';
import { ItemAdjuntoList } from '../Formulario/itemAdjunto';
import { TIPOINIT } from '../../../components/Listas/TiposAdjunto/constants';

export const FormularioAdjuntar = (props)=>{
  
  const {onSave, selected, isUpload, onClose, dataTamañoAdjuntos} = props
  const [adjuntos, setAdjuntos] = useState({})
  const [filesToSave, setFilesToSave] = useState([]);

  useEffect(() => {
    if(adjuntos.length>0){
    const newFiles = [];
    Object.keys(adjuntos).forEach((item, i) => {
      newFiles.push({file:adjuntos[item], tipo: TIPOINIT});
    });
    setFilesToSave([...filesToSave, ...newFiles]);
  }
  }, [adjuntos]);

  const getData = () =>{
    return {
      IdsPartes: selected.map(s=>s.idParte),  
      adjuntos: (filesToSave.length>0?filesToSave:undefined)
    }
  }

  const onSaveData = () =>{
    onSave && onSave(getData())
  }

  const onChange = (files) => {
    setAdjuntos(files);
  };


  const getSizeAdjuntos = useMemo(()=>{
    const tam = filesToSave.length>0 ? filesToSave.map((item, i) => (item.file.size)).reduce((total, size) =>{return total + size;}) : 0
    const kb = (tam / 1024);
    return (kb/1024)
    //return kb>1024 ? `${toDecimalString((kb/1024))} MB` : `${toDecimalString(kb)} KB`
  },[filesToSave,toDecimalString])

  const isInvalidTamañoAdjuntos = useMemo(()=>
  (dataTamañoAdjuntos.filter((f)=> (f.tamañoAdjuntos+getSizeAdjuntos)>20).length > 0)
  ,[getSizeAdjuntos, dataTamañoAdjuntos])

  const onChangeTypeAdjunto = (adjunto)=>{
    let pos = filesToSave.findIndex((o) => o.file.name === adjunto.file.name);
    let newData = [ ...filesToSave ];
		newData[pos] = adjunto;
    setFilesToSave(newData)
  }

  const onRemove = (itemRemove) =>{
    let pos = filesToSave.findIndex((o) => o.name === itemRemove);
    let newData = [ ...filesToSave ];
    newData.splice(pos, 1);
    setFilesToSave([...newData])
  }

const getExtraAction = (o) => {
    return{
        color: 'danger',
        onClick: ()=>onRemove(o.name),
        iconType: 'crossInACircleFilled',
        iconSize: 's',
        alwaysShow: true,
      }
  }

const renderOptions = () =>{
    return filesToSave.map((o)=>{
      return <ItemAdjuntoList item={o} extraAction={getExtraAction} changeType={onChangeTypeAdjunto}/>
    })
  }

const getList = () =>{
    return filesToSave.length>0 ? 
    <>
        <EuiListGroup style={{maxWidth:'100%',maxHeight:'300px',overflow:'auto'}}>
        {renderOptions()}
        </EuiListGroup>
    </>
    :
    <EuiFlexItem grow={false} key="danger">
    <EuiBadge color="danger">Sin datos</EuiBadge>
    </EuiFlexItem> 
}

 const errorNuevosAdjuntosPanel = useMemo(()=>{
    return getSizeAdjuntos > 20 ? 
    <>
    <EuiBadge style={{color:'#BD271E', width:'100%'}} color="#f8e9e9" iconType="cross" iconSide="left">
      {`Los adjuntos agregados sobrepasan los 20 MB de tamaño.`}
    </EuiBadge>
    <EuiSpacer size='m'/>
    </>
    :null
    },[,getSizeAdjuntos])


    const errorAdjuntosPartesPanel = useMemo(()=>{
    return isInvalidTamañoAdjuntos ? 
    <>
    <EuiBadge style={{color:'#BD271E', width:'100%'}} color="#f8e9e9" iconType="cross" iconSide="left">
      {`Al menos, uno de los partes seleccionados sobrepasa el límite de 20 MB de tamaño al incluir estos adjuntos.`}
    </EuiBadge>
    <EuiSpacer size='m'/>
    </>
    :null
    },[,isInvalidTamañoAdjuntos])
  

  const isInvalidUpload = useMemo(()=>( isInvalidTamañoAdjuntos || getSizeAdjuntos>20),[isInvalidTamañoAdjuntos, getSizeAdjuntos])

  return (
    <>
    {errorNuevosAdjuntosPanel}
    {errorAdjuntosPartesPanel}
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth hasEmptyLabelSpace>
          <AdjuntarComponent
              multiple
              onChange={onChange}
            />
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFormRow fullWidth labelAppend={`Tamaño: ${toDecimalString(getSizeAdjuntos)} MB`}>
          {getList()}
        </EuiFormRow>
      </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer size="m" />
      
    <EuiFormRow fullWidth>
      {isUpload ? 
      <EuiProgress size="m" color="subdued" />
      :
      <EuiFlexGroup>
        <EuiFlexItem>
          <EuiButton fullWidth onClick={onSaveData} disabled={isInvalidUpload}>
            Guardar
          </EuiButton>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiButton fullWidth color="danger" onClick={()=>onClose()} >Cancelar</EuiButton>
        </EuiFlexItem>
      </EuiFlexGroup>
      }
    </EuiFormRow>
    </>
  )
}
export default FormularioAdjuntar